// This file is auto-generated by the generateModuleTranslationKeys Vite plugin.
// Do not edit this file manually.
import { useTypedTranslation } from "@/shared/culture/useTypedTranslation";

export const COMMON_TRANSLATIONS = {
  "common.loading": "Loading...",
  "common.nextStep": "Next step",
  "common.no": "No",
  "common.privacyPolicy": "Privacy Policy",
  "common.register": "Register",
  "common.responsibleDisclosure": "Responsible Disclosure",
  "common.returnToLogin": "Return to Login",
  "common.signIn": "Sign in",
  "common.signInWithMicrosoft": "Sign in with Microsoft",
  "common.signUpWithMicrosoft": "Sign up with Microsoft",
  "common.termsOfUse": "Terms of Use",
  "common.yes": "Yes",
} as const;

export const COMMON_PLURAL_KEYS = {} as const;

export type CommonTranslationKey = keyof typeof COMMON_TRANSLATIONS;
export type CommonPluralTranslationKey = keyof typeof COMMON_PLURAL_KEYS;

/**
 * Typed translation hook for shared/global keys (navigation, topbar, common, etc.).
 * For module-specific keys, use useTypedTranslation<YourModuleTranslationKey>() instead.
 */
export function useCommonTranslation() {
  return useTypedTranslation<
    CommonTranslationKey,
    typeof COMMON_TRANSLATIONS,
    CommonPluralTranslationKey
  >(COMMON_TRANSLATIONS, COMMON_PLURAL_KEYS);
}
